export default __webpack_public_path__ + "static/media/Shot_1.0000.cbaae994.png";